import React, { useContext, useEffect } from "react";
import { RulesContext } from "../../RulesContext";
import { COND, OP } from "../../misc/RuleObjectTypes";
import arrayMove from "array-move";
import ConditionOperator from "./ConditionOperator";
import Condition from "./Condition";
import NestedCondition from "./NestedCondition";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";

const RuleBody = ({ ruleBody }) => {
  const { ruleDispatch, ruleState } = useContext(RulesContext);
  const { rule } = ruleState;

  useEffect(() => {
    if (ruleBody) {
      ruleDispatch({
        type: "UPDATE_RULE",
        updatedRule: ruleBody.rule,
      });
    }
  }, [ruleBody]);

  const setPleaseSelect = (arr, index, attrString) => {
    arr[index][attrString] = "Please Select";
  };
  const onSortEnd = ({ oldIndex, newIndex }) => {
    let final = [...rule];
    const left = "leftAttrID";
    const right = "rightAttrID";

    if (final[newIndex].type === "Operator") {
      arrayMove.mutate(final, oldIndex, newIndex);
      arrayMove.mutate(final, oldIndex, newIndex);
    } else if (oldIndex > newIndex) {
      arrayMove.mutate(final, oldIndex, newIndex);
      arrayMove.mutate(final, oldIndex, newIndex + 1);
    } else if (oldIndex < newIndex) {
      arrayMove.mutate(final, oldIndex, newIndex);
      arrayMove.mutate(final, oldIndex, newIndex - 1);
    } else {
      arrayMove.mutate(final, oldIndex, newIndex);
    }

    if (!Array.isArray(final[newIndex])) {
      final[newIndex]["position"] = newIndex.toString();
    }

    if (!Array.isArray(final[oldIndex])) {
      final[oldIndex]["position"] = oldIndex.toString();
    }
    
    final.map((item, index) => {
      if (Array.isArray(item)) {
        item.map((subItem, subIndex) => {
          if (Array.isArray(subItem)) {
            subItem.map((sItem, sIndex) => {
              sItem["position"] = `${index}-${subIndex}-${sIndex}`.toString();
            });
          } else {
            subItem["position"] = `${index}-${subIndex}`.toString();
          }
        });
      } else {
        item["position"] = index.toString();
      }
    });
    if (final[oldIndex][left] === undefined) {
      setPleaseSelect(final, oldIndex, left);
    }
    if (final[oldIndex][right] === undefined) {
      setPleaseSelect(final, oldIndex, right);
    }
    if (final[newIndex][left] === undefined) {
      setPleaseSelect(final, newIndex, left);
    }
    if (final[newIndex][right] === undefined) {
      setPleaseSelect(final, newIndex, right);
    }

    ruleDispatch({
      type: "UPDATE_RULE",
      updatedRule: final,
    });
  };

  return (
    <div>
      <SortableList
        rule={rule}
        onSortEnd={onSortEnd}
        useDragHandle={true}
        hideSortableGhost={true}
      />
    </div>
  );
};

const SortableList = SortableContainer(({ rule }) => {
  return (
    <ul className="tw-my-6">
      {rule.map((element, eleindex) => {
        return (
          <SortableItem
            key={`item-${element.position}`}
            index={eleindex}
            ind={eleindex}
            element={element}
            rule={rule}
            disabled={element.type === "Operator"}
          />
        );
      })}
    </ul>
  );
});
const DragHandle = SortableHandle(() => (
  <i className="fas fa-bars" style={{ color: "#adb5bd" }} />
));

const SortableItem = SortableElement(({ element, index, ind, rule }) => {
  if (Array.isArray(element)) {
    //render a nested condition, it needs special handling
    return (
      <div key={index} className="p-0 m-0">
        {rule.length > 1 && <DragHandle />}

        <NestedCondition
          {...{
            index,
            element,
            rootPosition: ind,
          }}
        />
      </div>
    );
  } else {
    switch (element.type) {
      case COND:
        return (
          <>
            <Condition
              key={index}
              {...{
                index,
                element,
                position: element.position,
                rootPosition: ind,
                DragHandle,
                rule,
              }}
            />
          </>
        );
      case OP:
        return (
          <>
            <div className="separator tw-mt-3" />
            <ConditionOperator
              key={index}
              {...{
                element,
                position: element.position,
              }}
            />
            
            <div className="separator tw-mb-3" />
          </>
        );
      default:
        return null;
    }
  }
});

export default RuleBody;
